import React from 'react';
import HiddenForm from './HiddenForm';
import { getBookmarkUrl } from '../utilities/urlHelper';

const BookmarkItem = ({
    pageId, folderId, externalResourceId, documentId, categoryId, bookmarkId, questionId,
}) => {
    const fields = pageId
        ? [{ name: 'pageId', value: pageId }]
        : externalResourceId
            ? [{ name: 'externalResourceId', value: externalResourceId }]
            : documentId
                ? [{ name: 'documentId', value: documentId }]
                : categoryId
                    ? [{ name: 'categoryId', value: categoryId }]
                    : questionId
                        ? [{ name: 'questionId', value: questionId }]
                        : [{ name: 'folderId', value: folderId }];

    return (
        !pageId && !folderId && !externalResourceId && !documentId && !categoryId && !questionId
            ? null
            : !bookmarkId
                ? <HiddenForm method="post" url={getBookmarkUrl(window.userId)} value="Bookmark" fields={fields} />
                : <HiddenForm method="delete" url={`${getBookmarkUrl(window.userId)}/${bookmarkId}`} value="Remove bookmark" />
    );
};

export default BookmarkItem;
